<template>
	<div :style="computedStyles" class="tickets-container">
		<v-app-bar color="#FBEB45">
			<logo-botones :width="200" :height="56" />
		</v-app-bar>
		<h1 class="title">Directorio de tiendas</h1>
		<v-container>
			<v-row>
				<v-spacer></v-spacer>
				<v-col cols="8">
					<v-text-field
						placeholder="Buscar por nombre, descripcion, ciudad"
						filled
						rounded
						outlined
						hide-details="auto"
						background-color="#e6e6e6"
						prepend-inner-icon="mdi-magnify"
						v-model="filter"
					/>
				</v-col>
				<v-spacer></v-spacer>
			</v-row>
		</v-container>
		<div class="cards-container">
			<ticket-card
				v-for="ticket in stores"
				:key="ticket.name"
				:ticket="ticket"
			/>
		</div>
		<h1 class="title" v-if="events.length > 0">Directorio de eventos</h1>
		<v-container v-if="events.length > 0">
			<v-row>
				<v-spacer></v-spacer>
				<v-col cols="8">
					<v-text-field
						placeholder="Buscar por nombre, descripcion"
						filled
						rounded
						outlined
						hide-details="auto"
						background-color="#e6e6e6"
						prepend-inner-icon="mdi-magnify"
						v-model="eventFilter"
					/>
				</v-col>
				<v-spacer></v-spacer>
			</v-row>
		</v-container>
		<div class="cards-container"  v-if="events.length > 0">
			<ticket-card
				v-for="ticket in filteredEvents"
				:key="ticket.name"
				:ticket="ticket"
			/>
		</div>
	</div>
</template>
<script>
import TicketCard from "../components/TicketCard.vue";
import LogoBotones from "../components/StoreChat/LogoBotones";
import { api } from "../ajax";
export default {
	components: {
		TicketCard,
		LogoBotones,
	},
	data: () => ({
		tickets: [],
		events: [],
		filter: "",
		eventFilter: ""
	}),
	methods: {
		getTickets() {
			api.get("web-store/index").then((response) => {
				this.tickets = response.data.data.filter((store) => !!store.image);
			});
		},
		getEvents() {
			api.get("/web-ticket/get_index").then((response) => {
				this.events = response.data.data;
			});
		},
	},
	computed: {
		stores() {
			let re = new RegExp(this.filter, "gi");
			return this.tickets.filter(
				(ticket) =>
					re.test(ticket.name) ||
					re.test(ticket.address.city) ||
					re.test(ticket.description)
			);
		},
		filteredEvents() {
			let re = new RegExp(this.eventFilter, "gi");
			return this.events.filter(
				(ticket) =>
					re.test(ticket.name) ||
					re.test(ticket.description)
			);
		},
		computedStyles() {
			return this.$store.getters["chatStore/getAppStyles"];
		},
	},
	created() {
		this.getTickets();
		this.getEvents();
	},
};
</script>
<style lang="scss">
@import "src/styles/variables.scss";
.tickets-container {
	content: "";
	width: 100%;
	height: 100%;
	overflow: hidden;
	// background-color: var(--main-bg);
	background-color: #262261;
	// @include botones-bg('#262261');
	background-repeat: repeat;
	background-size: 200px 200px;
	.v-toolbar__content {
		justify-content: flex-start;
	}
	svg {
		width: 180px !important;
		height: 32px !important;
		margin: 0 auto 0 0 !important;
		* {
			fill: #262261 !important;
		}
	}
	img {
		max-height: 210px;
		max-width: 210px;
	}
}
.cards-container {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;
	padding: 8px;
}
.title {
	margin-top: 20px;
	color: white;
	text-align: center;
}
</style>
